import { getCookie, saveCookie } from '@strata/cookies';
import { useEffect, useState } from 'react';
import wretch from 'wretch';

import { ENVIRONMENT_COOKIE_KEY } from 'services/constants';
import { handleError } from 'services/Error';

interface Auth0Info {
    domain: string;
    clientId: string;
    audience: string;
}

export const useAuth0Info = () => {
    const [auth0Info, setAuth0Info] = useState(getCookie<Auth0Info>(ENVIRONMENT_COOKIE_KEY));

    useEffect(() => {
        if (!auth0Info?.clientId) {
            (async () => {
                try {
                    setAuth0Info(
                        await wretch(process.env.REACT_APP_BASE_URL)
                            .url(
                                `/authorization/authentication_info/strata/${process.env.REACT_APP_ENV}`,
                            )
                            .get()
                            .json(
                                (result: {
                                    domain: string;
                                    client_id: string;
                                    audience: string;
                                    claim_base: string;
                                }) => {
                                    const info = {
                                        domain: result.domain,
                                        clientId: result.client_id,
                                        audience: result.audience,
                                    };

                                    saveCookie(ENVIRONMENT_COOKIE_KEY, info, 1);
                                    return info;
                                },
                            ),
                    );
                } catch (err) {
                    handleError('Error loading environment.', err as Error);
                }
            })();
        }
    }, [auth0Info]);

    return auth0Info;
};
